export default __webpack_public_path__ + "static/media/Tread-White.8057fa56.svg";